import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_N_FEATURE_MANAGEMENT = '/spe-n-feature-management';
let SpeNFeatureManagementProxy = class SpeNFeatureManagementProxy {
    constructor(api) {
        this.api = api;
    }
    getMenu(uuidAccountPayment, uuidWl) {
        const uri = `${SPE_N_FEATURE_MANAGEMENT}/v1/feature/all?uuidAccountPayment=${uuidAccountPayment}&uuidWl=${uuidWl}&page=1&limit=10000`;
        return this.api.get(uri);
    }
    getMenuV2(uuidAccountPayment, uuidWl) {
        const uri = `${SPE_N_FEATURE_MANAGEMENT}/v2/feature/all?uuidAccountPayment=${uuidAccountPayment}&uuidWl=${uuidWl}&page=1&limit=10000`;
        return this.api.get(uri);
    }
    getFavorites() {
        const uri = `${SPE_N_FEATURE_MANAGEMENT}/v1/favorites`;
        return this.api.get(uri);
    }
    deleteFavorite(uuid) {
        const uri = `${SPE_N_FEATURE_MANAGEMENT}/v1/favorites/${uuid}`;
        return this.api.delete(uri);
    }
    updateFavorite(uuid, body) {
        const uri = `${SPE_N_FEATURE_MANAGEMENT}/v1/favorites/${uuid}`;
        return this.api.put(uri, body);
    }
    postFavorite(body) {
        const uri = `${SPE_N_FEATURE_MANAGEMENT}/v1/favorites`;
        return this.api.post(uri, body);
    }
};
SpeNFeatureManagementProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNFeatureManagementProxy = __decorate([
    Injectable()
], SpeNFeatureManagementProxy);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

let UiPxFeatureManagementModule = class UiPxFeatureManagementModule {
};
UiPxFeatureManagementModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeNFeatureManagementProxy,
            ConfigService
        ]
    })
], UiPxFeatureManagementModule);

/*
 * Public API Surface of ui-bs-signup-proxy
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeNFeatureManagementProxy, UiPxFeatureManagementModule };
//# sourceMappingURL=wlp-ui-px-manager-feature.js.map
